export default {
  appData: (state) => state.appData,
  isLoading: (state) => state.loading,
  actionLoading: (state) => state.actionLoading,
  totalPartnerShare: (state) => state.total_partner_share,
  sorting: (state) => state.sorting,
  stats: (state) => state.stats,
  error: (state) => state.error,
  appsList: (state) => state.appsList,
  statsData: (state) => state.statsData,
}
